import request, { METHODS } from '@/api'
import { getNowUserInfo } from '@/utils/common';

export const getAuth = () => parseLocalStorage('buttonAuth', {})

// export const getAllMenu = () => parseSessionStorage('_all_menu')

// export const saveAllMenu = data => sessionStorage.setItem('_all_menu', JSON.stringify(data))
function parseStorage(item, defaultValue = null) {
  if (item && item !== 'undefined') {
    return JSON.parse(item)
  }
  return defaultValue
}
export const getTheme = () => parseLocalStorage('ANTD_CONFIG_PROVIDER', {})

function parseLocalStorage(key, defaultValue: any = null) {
  const item = localStorage.getItem(key)
  return parseStorage(item, defaultValue)
}

// function parseSessionStorage(key, defaultValue = null) {
//   let item = sessionStorage.getItem(key)
//   return parseStorage(item, defaultValue)
// }

/**
 * 动态获取按钮显示规则
 * type: 指定固定值
 * codes: 自定义字符传
 */
export function getActiveBtn({ type, codes = [] }: { type?: any, codes?: any[] }) {
  let btnCodes: any[] = []
  const fn = {
    clue: () => {
      [
        { title: '退回', code: 'BackButton' },
        { title: '交叉派单', code: 'CrossDispatchButton' },
        { title: '提交待定', code: 'SubmitThePendingButton' },
        { title: '提交普通信息', code: 'SendNormalButton' },
        { title: '预约到店', code: 'YuYueDaoDianButton' },
        { title: '确认到店', code: 'ConfirmDaoDianButton' },
        { title: '提交无效', code: 'SendUnNormalButton' },
        { title: '补软/定派单', code: 'AssignOthers' },
      ].map(item => {
        btnCodes.push(item.code)
      })
    },
    callCenter: () => {
      //呼叫中心
      [
        { title: '提交待定', code: 'SubmitThePending' },
        { title: '指定派单', code: 'CallClueAssignOrders' },
        { title: '派单', code: 'CallClueAssign' },
        { title: '提交无效', code: 'SubmitTheInvalid' },
        { title: '编辑', code: 'CallClueEdit' },
      ].map(item => {
        btnCodes.push(item.code)
      })
    },
    public: () => {
      [
        { title: '营销公海池领取', code: 'YXHighSeasPoolGet' },
        { title: '营销公海池分配', code: 'YXHighSeasPoolAssign' },
        { title: '营销公海池批量领取', code: 'YXBatchHighSeasPoolGet' },
        { title: '营销公海池批量分配', code: 'YXBatchHighSeasPoolAssign' },
      ].map(item => {
        btnCodes.push(item.code)
      })
    },
    clueBusiness: () => {
      [
        { title: '改派营销员', code: 'ReAssignSalesmanButton' },
        { title: '改派电商专员', code: 'ReAssignCommerceAttacheButton' },
        { title: '改派非营销', code: 'ReassignmentNonmarketingButton' },
        { title: '改派外部非营销', code: 'ReassignmentExternalNonmarketing' },
      ].map(item => {
        btnCodes.push(item.code)
      })
    },
    crmBusiness: () => {
      [
        { title: '是否收费', code: 'chargeFlagButton' },
        { title: '改派营销员', code: 'ReAssignSalesmanButton' },
        { title: '改派设计师', code: 'ReAssignDesignerButton' },
        { title: '改派电商专员', code: 'DistributionESalemanButtons' },
        { title: '改派电商专员2', code: 'ReAssignCommerceAttacheButton' },
        { title: '改派非营销', code: 'DistributionFSalemanButtons' },
        { title: '改派云客服', code: 'CallClueTransfer' },
        { title: '关联交付业绩人员', code: 'DeliveryAchievement' },
        { title: '改派外部非营销', code: 'ReassignmentExternalNonmarketing' },
        { title: '关联业绩设计师', code: 'yejiDesigner' },
        { title: '改派定制设计师', code: 'ReassignmentWardrobeDesigner' },
        { title: '改派橱柜设计师', code: 'ReassignmentchuGuiWardrobeDesign' },
        { title: '硬装开工', code: 'ApplyProjectButton' },
        { title: '软装开工', code: 'softProjectButton' },
        { title: '贷款更新', code: 'creditUpdateBtn' },
        { title: '基金申请', code: 'crmBundApplicationBtn' },
        { title: '开启/关闭异常退单', code: 'abnormalChargebackButton' },
        { title: '复制需求', code: 'copyBusinessOP' },
        { title: '领取需求', code: 'listReBackBizop' },
        { title: '指定分配', code: 'Assignment' },
        { title: '指定', code: 'SJHighSeasPoolAssign' },
        { title: '领取', code: 'SJHighSeasPoolGet' },
        { title: '批量指定', code: 'SJBatchHighSeasPoolAssign' },
        { title: '批量领取', code: 'SJBatchHighSeasPoolGet' },
        { title: '分配设计师', code: 'DistributionDesignerButton' },
        { title: '分配营销员', code: 'DistributionSalemanButton' },
        { title: '上传施工图纸', code: 'uploadDrawingsBtn' },
        { title: '分配设计部', code: 'DistributionDesignerManagerButton' },
        { title: '提交开工', code: 'ApplyProjectButtonJMS' },
        { title: '提交完工', code: 'ApplyProjectEedButtonJMS' },
      ].map(item => {
        btnCodes.push(item.code)
      })
    },
    crmBusinessDetail: () => {
      [
        { title: '预约到店', code: 'YuYueDaoDianButton' },
        { title: '提交无效', code: 'SendUnNormalButton' },
        { title: '确认到店', code: 'ConfirmDaoDianButton' },
        { title: '提交飞单', code: 'SendFeiDanButton' },
        { title: '提交定金', code: 'DingJingBizButton' },
        { title: '退定', code: 'TuiDingButton' },
        { title: '退单', code: 'TuiDanButton' },
        { title: '退单重签', code: 'TuiDanBackButton' },
        { title: '退余额', code: 'TuiKuanButton' },
        { title: '退设计费', code: 'designFeeBackButton' },
        { title: '冻结需求', code: 'freezeBizBtn' },
        { title: '解冻需求', code: 'unfreezeBizBtn' },
        { title: '修改客户来源', code: 'EditChannelName' },
        { title: '修改设计服务起始日', code: 'designServiceStartDate' },
        { title: '楼盘地址变更', code: 'changeRealEstateAddress' },
        { title: '跟进计划', code: 'AddfollowUpPlanButton' },
        { title: '跟进计划', code: 'AddfollowUpPlanButton' },
        { title: '退单', code: 'TuiDanButtonJMS' },
        { title: '退订', code: 'TuiDingButtonJMS' },
        { title: '楼盘地址变更', code: 'changeRealEstateAddressJMS' },
      ].map(item => {
        btnCodes.push(item.code)
      })
    },
    crmBusinessPending: () => {
      [
        { title: '分配电商专员（即派单按钮）', code: 'DistributionESalemanButtons' },
        { title: '分配营销部经理（即派单按钮）', code: 'DistributionSalesManagerButton' },
        { title: '分配营销员（即派单按钮）', code: 'DistributionSalemanButton' },
        { title: '分配设计部经理（即派单按钮）', code: 'DistributionDesignerDepartmentButton' },
        { title: '分配设计师（即派单按钮）', code: 'DistributionDesignerButton' },
      ].map(item => {
        btnCodes.push(item.code)
      })
    },
  }[type]
  fn ? fn() : (btnCodes = codes)
  // /biz/queryBtnByBizStateAndPos
  // /api-crm/crm/common/bizop/queryBtnByBizStateAndPos
  return request(`/crm-web/biz/queryBtnByBizStateAndPos`, { method: METHODS.POST, data: { btnCodes } })
    .then(res => {
      return res || []
    })
    .catch(err => [])
}

/**
 * 处理按钮权限数据
 */
export function processButtonData(params: { arr: any, stateCode?: any }) {
  const { arr = [], stateCode } = params;
  const postCode = getNowUserInfo('postCode')
  console.log('getButton---<', postCode)
  const obj = {}
  arr.map(item => {
    obj[item.buttonKey] = false
    if (item?.posCodes && item?.taskType && stateCode) {
      item?.posCodes.split(',').map(itemPos => {
        item?.taskType.split(',').map(itemStates => {
          if (postCode) {
            if (itemPos == postCode && itemStates == stateCode) {
              obj[item.buttonKey] = true
            }
          } else {
            obj[item.buttonKey] = true
          }
        })
      })
    } else if (item?.posCodes) {
      item?.posCodes.split(',').map(itemPos => {
        if (postCode) {
          if (itemPos == postCode) {
            obj[item.buttonKey] = true
          }
        } else {
          obj[item.buttonKey] = true
        }
      })
    } else if (item?.taskType && stateCode) {
      item?.taskType.split(',').map(itemStates => {
        if (itemStates == stateCode) {
          obj[item.buttonKey] = true
        }
      })
    } else {
      obj[item.buttonKey] = true
    }
  })
  // console.log('arr:',arr,'stateCode:',stateCode,'processButtonData:',obj);
  return obj
}

export const getHandleButtonObj = (arr) => {
  const obj = {} ;
  arr.forEach(item => { obj[item.buttonKey] = true })
  return obj
}

/**
 * 处理.json里面按钮渲染方式
 */
export function processAuthButtonData(obj = {}) {
  const authObj = getAuth() || {}
  const newObj = {}
  for (const authObjKey in authObj) {
    for (const objKey in obj) {
      if (authObjKey == objKey && obj[objKey]) {
        newObj[`${objKey}Auth`] = obj[objKey]
      }
    }
  }
  return newObj
}